import { Component } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthorizeApi } from "../authorize-api";
import { combineLatest, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  success: boolean = false;
  error: boolean = false;

  username = new FormControl(null, [Validators.required, Validators.email]);
  password = new FormControl(null, [Validators.required]);
  submitted = false;

  constructor(private router: Router, private api: AuthorizeApi) {
    combineLatest([
      this.username.valueChanges,
      this.password.valueChanges,
    ]).subscribe(([username, password]) => {
      if (!!username && !!password && username != "" && password != "")
        this.success = true;
    });
  }

  onSubmit() {
    if (
      !!this.username.value &&
      !!this.password.value &&
      this.username.value != "" &&
      this.password.value != ""
    ) {
      this.error = false;
      this.api
        .login({
          email: this.username.value,
          password: this.password.value,
          id: "",
        })
        .pipe(
          switchMap((logged) =>
            logged ? this.api.getConnectedUser() : of(null)
          )
        )
        .subscribe((connectedUser) => {
          if (connectedUser) {
            this.api.connectedUser$.next(connectedUser);
            this.router.navigate(["/"]);
          } else this.error = true;
        });
    }
  }
}
